import React from "react";
import formElementAnnotatedStyle from "./formElementAnnotatedStyle";
import { Box, Typography } from "@mui/material";
import FormElementReactHookForm, { FormElementReactHookFormProps } from "./FormElementReactHookForm";

export type FormElementAnnotatedProps = {
  headline: string;
  description: string;
} & FormElementReactHookFormProps;
const FormElementAnnotated = ({ headline, description, ...rest }: FormElementAnnotatedProps) => {
  return (
    <>
      <Typography variant={"h3"}>{headline}</Typography>
      <br />
      <Typography>{description}</Typography>
      <Box sx={formElementAnnotatedStyle.field}>
        <FormElementReactHookForm {...rest} />
      </Box>
    </>
  );
};

export default FormElementAnnotated;
